import { z } from 'zod';
import { FlowDataSchema } from './flowData.js';
/**
 * Body `POST /flow-definitions/block-rename` accepts. Structural validation only: flow-api
 * additionally checks that the graph's database references resolve.
 *
 * The block already carries its new name in `flowData`; `oldBlockName` is what the rest of the
 * graph still refers to it by, and is what the rename rewrites.
 */
export const FlowDefinitionBlockRenameBodySchema = z.strictObject({
    flowData: FlowDataSchema.describe('The graph containing the renamed block.'),
    blockId: z.uuid().describe('The renamed block.'),
    oldBlockName: z.string().describe('The name the block had before the rename.'),
});
//# sourceMappingURL=blockRenameRequest.js.map